import Toast from 'bootstrap/js/src/toast.js'

// Initialize and show Bootstrap toasts
document.addEventListener('DOMContentLoaded', () => {
  const toastElements = document.querySelectorAll('.toast')
  toastElements.forEach(toastEl => {
    const toast = new Toast(toastEl)
    toast.show()
  })
})
